angular
  .module('app.components')
  .directive('dailyImpressionsChart',
    ['$filter', 'ChartService',
      ($filter, ChartService) => ({
      restrict: "E",
      scope: {
        data: '=',
        interactive: '=',
        identifier: '@'
      },
      template: '<highchart id="{{identifier}}" config="config"></highchart>',
      link: scope => {
        scope.$watch('data', newValue => {
          if (newValue) scope.config.refreshData(newValue);
        }, true);
      },

      // NOTE: DO NOT move the config options to the link function.
      // See : https://github.com/pablojim/highcharts-ng/issues/384
      controller: $scope => {
        $scope.id = $scope.identifier;
        const options = ChartService.getBaseChartConfig();

        angular.merge(options, {
          chart: {
            spacingTop: 10
          },
          tooltip: {
            formatter: function () {
              return `
                <h4>${$scope.dateLabels[this.x]}</h4>
                <div class="highcharts-tooltip-outer">
                  <table class="highcharts-tooltip-inner">
                    <tr>
                      <td class="td-left">${this.points[0].series.name}:</td>
                      <td class="td-right">${$filter('customNumber')(this.y)}</td>
                    </tr>
                  </table>
                </div>`;
            }
          },
          legend: {
            enabled: false
          },
          xAxis: {
            labels: {
              formatter: function () {
                return $scope.dateLabels ? $scope.dateLabels[this.value] : '';
              },
              rotation: -90
            }
          },
          plotOptions: {
            areaspline: {}
          },
        });

        $scope.config = {
          options,
          refreshData: function(source) {
            if (angular.isUndefined(source)) return;

            $scope.dateLabels = _.pluck(_.values(source), 'date');
            this.series = [{
              name: 'Impressions',
              data: _.pluck(_.values(source), 'count'),
              enableMouseTracking: $scope.interactive,
              color: options.colors[0]
            }];
          }
        };
      }
    })
]);
